import type { BoxDetail, CreateLootClient, LootApiLike } from "@loot-os/react";

/** Thrown if the preview opener ever tries to write; it runs in demo mode, so it cannot. */
function unreachable(method: string): never {
  throw new Error(`[preview] ${method} must never run in the Appearance preview`);
}

/**
 * A client that can only describe one box, for the Appearance screen's opener. Passed as the
 * opener's `createClient` (not `client`), which keeps the SDK in demo mode: spins roll locally
 * and nothing is written. The dashboard's `previewOpenerClient` is the same trick.
 */
export function previewClient(box: BoxDetail): CreateLootClient {
  return () => {
    const client: LootApiLike = {
      getBox: () => Promise.resolve(box),
      openBox: () => unreachable("openBox"),
      claimReveal: () => unreachable("claimReveal"),
      getUnclaimedReveal: () => Promise.resolve(null),
    };
    return client;
  };
}
